// 替换uni-app的API为Web标准API

const AUTH_STORAGE_KEYS = new Set(['token', 'username'])

// 旧版本把登录凭证永久保存在 localStorage，会导致共用浏览器串号。
// 新版本只保留当前浏览器会话，并在加载时清除旧凭证。
AUTH_STORAGE_KEYS.forEach(key => localStorage.removeItem(key))

const emitAuthChanged = (authenticated) => {
  window.dispatchEvent(new CustomEvent('auth-session-changed', {
    detail: { authenticated }
  }))
}

// 替换uni.showToast
export const showToast = (options) => {
  // 创建一个简单的toast提示
  const toast = document.createElement('div')
  toast.style.position = 'fixed'
  toast.style.top = '50%'
  toast.style.left = '50%'
  toast.style.transform = 'translate(-50%, -50%)'
  toast.style.padding = '10px 20px'
  toast.style.backgroundColor = 'rgba(0, 0, 0, 0.7)'
  toast.style.color = 'white'
  toast.style.borderRadius = '4px'
  toast.style.zIndex = '9999'
  toast.textContent = options.title || '提示'
  
  document.body.appendChild(toast)
  
  // 2秒后自动移除
  setTimeout(() => {
    document.body.removeChild(toast)
  }, options.duration || 2000)
}

// 替换uni.navigateTo
export const navigateTo = (options) => {
  // 使用Vue Router进行页面跳转
  if (window.router) {
    let url, path, query, params = {};
    
    // 处理两种情况：字符串路径和对象
    if (typeof options === 'string') {
      url = options.startsWith('/') ? options.substring(1) : options;
    } else if (options.url) {
      url = options.url.startsWith('/') ? options.url.substring(1) : options.url;
    } else {
      console.error('navigateTo: 无效的参数', options);
      return;
    }
    
    // 提取路径和参数
    [path, query] = url.split('?');
    
    if (query) {
      query.split('&').forEach(param => {
        const [key, value] = param.split('=');
        params[key] = decodeURIComponent(value || '');
      });
    }
    
    window.router.push({ path: '/' + path, query: params });
  } else {
    console.error('navigateTo: router未初始化');
  }
}

// 替换uni.redirectTo
export const redirectTo = (options) => {
  if (window.router && options.url) {
    const url = options.url.startsWith('/') ? options.url.substring(1) : options.url
    const [path, query] = url.split('?')
    
    let params = {}
    if (query) {
      query.split('&').forEach(param => {
        const [key, value] = param.split('=')
        params[key] = decodeURIComponent(value || '')
      })
    }
    
    window.router.replace({ path: '/' + path, query: params })
  }
}

// 替换uni.setStorageSync
export const setStorageSync = (key, value) => {
  try {
    const storage = AUTH_STORAGE_KEYS.has(key) ? sessionStorage : localStorage
    if (value === '' || value === null || value === undefined) {
      storage.removeItem(key)
    } else {
      storage.setItem(key, JSON.stringify(value))
    }
  } catch (e) {
    console.error('存储数据失败:', e)
  }
}

// 替换uni.getStorageSync
export const getStorageSync = (key) => {
  try {
    const storage = AUTH_STORAGE_KEYS.has(key) ? sessionStorage : localStorage
    const value = storage.getItem(key)
    if (!value) return null
    
    // 尝试解析JSON，如果失败则返回原始值
    try {
      return JSON.parse(value)
    } catch (parseError) {
      // 如果不是有效的JSON，直接返回原始值
      return value
    }
  } catch (e) {
    console.error('获取数据失败:', e)
    return null
  }
}

// 替换uni.removeStorageSync
export const removeStorageSync = (key) => {
  try {
    sessionStorage.removeItem(key)
    localStorage.removeItem(key)
  } catch (e) {
    console.error('删除数据失败:', e)
  }
}

export const clearAuthSession = () => {
  AUTH_STORAGE_KEYS.forEach(key => {
    sessionStorage.removeItem(key)
    localStorage.removeItem(key)
  })
  emitAuthChanged(false)
}

export const notifyAuthenticated = () => {
  emitAuthChanged(true)
}

// 替换uni.getSystemInfoSync
export const getSystemInfoSync = () => {
  return {
    platform: 'browser',
    windowWidth: window.innerWidth,
    windowHeight: window.innerHeight,
    screenWidth: window.screen.width,
    screenHeight: window.screen.height
  }
}

// 替换uni.request
export const request = (options) => {
  return new Promise((resolve, reject) => {
    const { url, method = 'GET', data, header = {} } = options
    
    // 使用axios发送请求
    import('../api').then(({ default: api }) => {
      api({
        url,
        method: method.toLowerCase(),
        data,
        headers: header
      })
      .then(response => {
        resolve({ data: response, statusCode: 200 })
      })
      .catch(error => {
        reject({ errMsg: error.message })
      })
    })
  })
}
